<template lang="pug">
  div
    section.content-header
      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 名寄せ候補名刺

    section.content
      .callout.callout-info.bcard-callout
        p 同一人物と思われる候補がある名刺を表示しています。
        p
          i.fa.fa-fw.fa-exclamation-circle
          |
          |
          | 同一人物、兼務または別人物であるかを判定してください。

      .panel.panel-default
        .panel-heading.text-right
          //- 一覧切り替えボタン
          portal-target(name="list_mode", tag="span")
          | &nbsp;&nbsp;
          app-sortmenu(:hidden="list.length === 0", :options="sortOptions", :current="sort" @change="sortList")

        loading(v-if="isLoading")
        card-list(
          v-else-if="list.length > 0",
          v-model="list",
          :sort="sort",
          :itemLocation="itemLocation"
        )
        .panel-body.text-center(v-else) 同一人物候補の名刺はありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppSortmenu from '@/components/molecules/AppSortmenu'
import Loading from '@/components/molecules/Loading'
import FuncAdvancedSearch from '@/components/organisms/functions/FuncAdvancedSearch'
import CardList from '@/components/organisms/lists/CardList'

export default {
  name: 'DuplicatedPersons',
  components: {
    AppMessages,
    AppPagination,
    AppSortmenu,
    Loading,
    FuncAdvancedSearch,
    CardList
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      sortOptions: [
        {'label': '氏名', 'sort_item': 'name'},
        {'label': '会社名', 'sort_item': 'corporate_name'},
        {'label': '部署名', 'sort_item': 'dept'},
        {'label': '役職', 'sort_item': 'post'},
        {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      ],

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 },
        // ソート条件
        sort: { sort_item: 'name', direction: 'asc' }
        // 検索条件
        // conds: {
        // }
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      this.sort = Object.assign({}, this.initParams.sort)
      // this.conditions = Object.assign({}, this.initParams.conds)
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this
      options = options || {}

      let page = options.page || this.pagination.current_page || 1
      let sort = options.sort || this.sort || {}
      // let conds = options.conds || this.conditions || {}

      let params = {
        // page
        page,
        // sort
        sort_item: sort.sort_item,
        direction: sort.direction
      }

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'bcard',
        method: 'searchNonjudged',
        params,
        finally () {
          vm.isLoading = false
        }
      })
    },
    itemLocation (item) {
      return {name: 'merge-persons-detail', params: {id: '' + item.sid_person}}
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/duplicated-persons/List.vue